import Splide from '@splidejs/splide';

const initTeamVideos = (slider) => {
  const slides = slider.querySelectorAll('.splide__slide').length;

  if (!slides) {
    return;
  }

  const useThumbnailFallback = (image) => {
    const fallbackSrc = image.dataset.fallbackSrc;

    if (fallbackSrc) {
      image.removeAttribute('data-fallback-src');
      image.src = fallbackSrc;
    }
  };

  slider.addEventListener(
    'error',
    (event) => {
      if (event.target.matches('img[data-fallback-src]')) {
        useThumbnailFallback(event.target);
      }
    },
    true
  );

  slider.addEventListener(
    'load',
    (event) => {
      if (
        event.target.matches('img[data-fallback-src]') &&
        event.target.naturalWidth < 480
      ) {
        useThumbnailFallback(event.target);
      }
    },
    true
  );

  const splide = new Splide(slider, {
    type: slides > 1 ? 'loop' : 'slide',
    perPage: 1,
    perMove: 1,
    focus: 0,
    gap: '2.813rem',
    padding: { right: '32.5%' },
    arrows: slides > 1,
    pagination: slides > 1,
    speed: 650,
    drag: slides > 1,
    keyboard: 'focused',
    breakpoints: {
      1024: {
        perPage: 1,
        gap: '1.5rem',
        padding: { right: '18%' },
      },
      640: {
        perPage: 1,
        gap: '0.75rem',
        padding: { right: '8%' },
      },
    },
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
    },
  });

  const updateSlideState = () => {
    slider.querySelectorAll('.splide__slide').forEach((slide) => {
      const playButton = slide.querySelector('.team-videos__play');

      if (playButton) {
        playButton.disabled = !slide.classList.contains('is-active');
      }
    });
  };

  const updateArrowPositions = () => {
    const track = slider.querySelector('.splide__track');
    const firstSlide = slider.querySelector('.splide__slide');

    if (!track || !firstSlide) {
      return;
    }

    const previousX = track.offsetLeft;
    const nextX = previousX + firstSlide.offsetWidth;

    slider.style.setProperty(
      '--team-videos-track-center',
      `${track.offsetTop + track.offsetHeight / 2}px`
    );
    slider.style.setProperty('--team-videos-prev-x', `${previousX}px`);
    slider.style.setProperty('--team-videos-next-x', `${nextX}px`);
  };

  splide.on('mounted', updateArrowPositions);
  // 'active'/'inactive' fire as Splide sets the classes this reads, so the state
  // is correct from the first paint. Listening for 'mounted' alone left every
  // play button disabled on load - the classes are not on the slides yet at
  // that point, and nothing re-enabled them until the carousel was moved.
  splide.on('active inactive moved refresh updated', updateSlideState);
  splide.on('resized', () => {
    updateArrowPositions();
  });
  splide.mount();
  updateSlideState();

  slider.querySelectorAll('img[data-fallback-src]').forEach((image) => {
    if (image.complete && image.naturalWidth < 480) {
      useThumbnailFallback(image);
    }
  });
};

const initAll = () => {
  document.querySelectorAll('.team-videos__slider').forEach((slider) => {
    if (slider.classList.contains('is-initialized')) {
      return;
    }

    initTeamVideos(slider);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
